// src/components/tutorials/html/TryItButtonHTML.jsx
import React from "react";

// 🔹 Try It Button Component
export default function TryItButtonHTML({ html = "", css = "", js = "" }) {
  const handleClick = () => {
    try {
      // Combine all 3 types of code
      const payload = { html, css, js };

      // Encode safely for URL
      const encoded = encodeURIComponent(JSON.stringify(payload));

      // Open the editor in a new tab with the code included
      window.open(`/editorHTML?code=${encoded}`, "_blank");
    } catch (err) {
      console.error("Error while encoding code for TryItButtonHTML:", err);
    }
  };

  return (
    <button className="try_it_button" onClick={handleClick}>
      ▶ Try It
    </button>
  );
}
